module.exports = __webpack_public_path__ + "img/andy.94e4560e.jpg";